function NextIcon() {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 7L25.5 15L19.5 23" stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default NextIcon;
